import { Badge } from "@/components/ui/badge";

// Canonical lifecycle: Draft → Pending → Awaiting approval → Approved → Ordered → (Partial) → Received.
export const PO_STATUS_LABEL = {
  draft: "Draft", pending: "Pending", submitted: "Awaiting approval", approved: "Approved",
  open: "Ordered", ordered: "Ordered", acknowledged: "Ordered", shipped: "Shipped", partial: "Partial",
  received: "Received", closed: "Received", cancelled: "Cancelled",
};
export const PO_STATUS_TONE = {
  draft: "bg-slate-100 text-slate-600", pending: "bg-amber-100 text-amber-700", submitted: "bg-orange-100 text-orange-700",
  approved: "bg-emerald-100 text-emerald-700", open: "bg-blue-100 text-blue-700", ordered: "bg-blue-100 text-blue-700",
  acknowledged: "bg-blue-100 text-blue-700", shipped: "bg-sky-100 text-sky-700", partial: "bg-indigo-100 text-indigo-700",
  received: "bg-emerald-100 text-emerald-700", closed: "bg-emerald-100 text-emerald-700", cancelled: "bg-red-100 text-red-700",
};
export const PO_STATUS_ORDER = ["draft", "pending", "submitted", "approved", "open", "ordered", "acknowledged", "shipped", "partial", "received", "closed", "cancelled"];

// One width for every status so a column of pills lines up.
export function POStatusPill({ status, testId, className = "" }) {
  return (
    <Badge variant="outline" data-testid={testId}
      className={`inline-flex min-w-[5.5rem] justify-center whitespace-nowrap border-0 text-[10px] ${PO_STATUS_TONE[status] || "bg-slate-100 text-slate-600"} ${className}`}>
      {PO_STATUS_LABEL[status] || status || "—"}
    </Badge>
  );
}
